mutation DiscardChanges($input: PageDiscardChangesInput!) {
    pageDiscardChanges(input: $input) {
        page {
            id
        }
    }
}
